'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = function(locale = window.userLang) {
    switch (locale) {
        case 'en_US':
            return {
                year: '',
                month: '',
                day: '',
                hour: '',
                minute: '',
                locale: 'en'
            };
        default:
            return {
                year: '年',
                month: '月',
                day: '日',
                hour: '',
                minute: '',
                locale: 'cn'
            };
    }
};
module.exports = exports['default'];



// WEBPACK FOOTER //
// ./src/components/util/zh_CN.js